/** Every synthesised track by name, compiled once on first use. Pure. */

import type { MusicTrack } from '../types';
import { EMPRESS } from './empress';
import { compileSong } from './score';
import { GAMEOVER, HISCORE, START } from './stings';
import { TITLE } from './title';
import type { Compiled, Song } from './types';

export const SONGS: Readonly<Record<MusicTrack, Song>> = {
  title: TITLE,
  start: START,
  empress: EMPRESS,
  hiscore: HISCORE,
  gameover: GAMEOVER,
};

const compiled = new Map<MusicTrack, Compiled>();

export function compiledSong(track: MusicTrack): Compiled {
  let c = compiled.get(track);
  if (!c) {
    c = compileSong(SONGS[track]);
    compiled.set(track, c);
  }
  return c;
}

/** Tracks that play through once and stop rather than loop: the score says which. */
export function playsOnce(track: MusicTrack): boolean {
  return !SONGS[track].loop;
}
